export function attachmentStickyStage(top: number, bottom: number, stickyBottom: number) {
  if (bottom <= stickyBottom) return "complete";
  return top <= stickyBottom ? "attachments" : "question";
}
